import React from 'react';

const PromptTagReferenceLabel = ({ items = [] }) => {
  if (!Array.isArray(items) || items.length === 0) {
    return null;
  }

  return (
    <div className="rounded-md border border-amber-200 bg-amber-50 px-3 py-2 text-xs text-amber-900">
      {items.map((item) => (
        <div key={`${item.tag}-${item.description}`} className="leading-5">
          <span className="font-semibold">{item.tag}</span>
          {' - '}
          <span>{item.description}</span>
        </div>
      ))}
    </div>
  );
};

export default PromptTagReferenceLabel;
